import { api } from "./http";

/** Docente: mis cursos (runs) asignados */
export async function teacherGetRuns() {
	const res = await api.get("/api/academic/teacher/runs/");
	return res.data;
}

/** Docente: detalle de un run con unidades, semanas, recursos */
export async function teacherGetRun(runId) {
	const res = await api.get(`/api/academic/teacher/runs/${runId}/`);
	return res.data;
}

/** Docente: crear unidad */
export async function teacherCreateUnit(runId, payload) {
	const res = await api.post(
		`/api/academic/teacher/runs/${runId}/units/`,
		payload,
	);
	return res.data;
}

/** Docente: actualizar unidad */
export async function teacherUpdateUnit(unitId, payload) {
	const res = await api.patch(
		`/api/academic/teacher/units/${unitId}/`,
		payload,
	);
	return res.data;
}

/** Docente: eliminar unidad */
export async function teacherDeleteUnit(unitId) {
	await api.delete(`/api/academic/teacher/units/${unitId}/`);
}

/** Docente: crear semana (módulo) en unidad */
export async function teacherCreateModule(unitId, payload) {
	const res = await api.post(
		`/api/academic/teacher/units/${unitId}/modules/`,
		payload,
	);
	return res.data;
}

/** Docente: actualizar semana */
export async function teacherUpdateModule(moduleId, payload) {
	const res = await api.patch(
		`/api/academic/teacher/modules/${moduleId}/`,
		payload,
	);
	return res.data;
}

/** Docente: eliminar semana */
export async function teacherDeleteModule(moduleId) {
	await api.delete(`/api/academic/teacher/modules/${moduleId}/`);
}

/** Docente: crear recurso (contenido) en semana. category: material | clases | evaluaciones */
export async function teacherCreateContent(moduleId, payload, file = null) {
	const form = new FormData();
	Object.entries(payload || {}).forEach(([k, v]) => {
		if (v != null && v !== "") form.append(k, v);
	});
	if (file) form.append("file", file);
	const res = await api.post(
		`/api/academic/teacher/modules/${moduleId}/contents/`,
		form,
		{
			headers: { "Content-Type": "multipart/form-data" },
		},
	);
	return res.data;
}

/** Docente: actualizar recurso (payload JSON; si file no es null, se envía FormData) */
export async function teacherUpdateContent(contentId, payload, file = null) {
	if (file) {
		const form = new FormData();
		Object.entries(payload || {}).forEach(([k, v]) => {
			if (v != null && v !== "") form.append(k, v);
		});
		form.append("file", file);
		const res = await api.patch(
			`/api/academic/teacher/contents/${contentId}/`,
			form,
			{
				headers: { "Content-Type": "multipart/form-data" },
			},
		);
		return res.data;
	}
	const res = await api.patch(
		`/api/academic/teacher/contents/${contentId}/`,
		payload || {},
	);
	return res.data;
}

/** Docente: eliminar recurso */
export async function teacherDeleteContent(contentId) {
	await api.delete(`/api/academic/teacher/contents/${contentId}/`);
}

/** Aula (estudiante/docente): mis cursos matriculados o asignados */
export async function aulaGetMyCourses() {
	const res = await api.get("/api/academic/aula/my-courses/");
	return res.data;
}

/** Aula: detalle de un run (unidades, semanas, recursos) */
export async function aulaGetRun(runId) {
	const res = await api.get(`/api/academic/aula/runs/${runId}/`);
	return res.data;
}

/** Aula: grabaciones visibles de un run */
export async function aulaGetRunRecordings(runId) {
	const res = await api.get(`/api/academic/aula/runs/${runId}/recordings/`);
	return res.data;
}

/** Estudiante: registra que abrió un recurso (enlace, archivo, clase). Actualiza el % de avance del curso. */
export async function markSurveyCompleted(runId, payload = {}) {
    const res = await api.post(`/api/academic/aula/runs/${runId}/survey-completed/`, payload);
    return res.data;
}

export async function aulaMarkContentViewed(contentId) {
	const res = await api.post(
		`/api/academic/aula/contents/${contentId}/viewed/`,
	);
	return res.data;
}

/** Estudiante: progreso y estado de un curso (run). Devuelve progress_percentage, exam_status, etc. */
export async function getCourseStatus(runId) {
	const res = await api.get(`/api/academic/course-status/${runId}/`);
	return res.data;
}

/**
 * Mensajería por hilo (estudiante ↔ docente por curso).
 * Estudiante: devuelve { thread: "mine", messages: [...] }.
 * Docente sin with: devuelve { threads: [...], messages: null }.
 * Docente con with: devuelve { thread: studentId, messages: [...] }.
 */
export async function getCourseMessages(runId, withStudentId = null) {
	const url =
		withStudentId != null
			? `/api/academic/aula/runs/${runId}/messages/?with=${withStudentId}`
			: `/api/academic/aula/runs/${runId}/messages/`;
	const res = await api.get(url);
	return res.data;
}

/** Enviar mensaje. Estudiante: body. Docente: body + recipientId (id del estudiante al que responde). */
export async function sendCourseMessage(runId, body, recipientId = null) {
	const payload = { body };
	if (recipientId != null) payload.recipient_id = recipientId;
	const res = await api.post(
		`/api/academic/aula/runs/${runId}/messages/`,
		payload,
	);
	return res.data;
}

/** Cantidad de mensajes no leídos (para el usuario actual como destinatario). */
export async function getMessageUnreadCount() {
	const res = await api.get("/api/academic/aula/message-unread-count/");
	return res.data?.unread_count ?? 0;
}

/** mensajes no leídos estudiantes del docente. */
export async function getUnreadStudents(runId) {
	const res = await api.get(
		`/api/academic/aula/runs/${runId}/messages/unread-students/`,
	);
	return res.data?.unread_students || [];
}

/** mensajes no leídos cursos del docente. */
export async function getUnreadCourses() {
	const res = await api.get("/api/academic/aula/messages/unread-courses/");
	return res.data?.unread_runs || [];
}

/** Docente: participantes de un run (docente + estudiantes activos). */
export async function teacherGetRunParticipants(runId) {
	const res = await api.get(
		`/api/academic/teacher/runs/${runId}/participants/`,
	);
	return res.data;
}

export async function teacherToggleExamAccess(enrollmentId) {
    const res = await api.post(`/api/academic/teacher/enrollments/${enrollmentId}/toggle-exam/`);
    return res.data;
}

/** Docente: estudiantes del run actual con actividad reciente. */
export async function teacherGetRunOnlineStudents(runId) {
	const res = await api.get(
		`/api/academic/teacher/runs/${runId}/online-students/`,
	);
	return res.data;
}

/** Docente: historial de avisos publicados para un run. */
export async function teacherGetRunAnnouncements(runId) {
	const res = await api.get(
		`/api/academic/teacher/runs/${runId}/announcements/`,
	);
	return res.data;
}

/** Docente: grabaciones del curso. */
export async function teacherGetRunRecordings(runId) {
	const res = await api.get(
		`/api/academic/teacher/runs/${runId}/recordings/`,
	);
	return res.data;
}

/** Docente: crear aviso y enviarlo por correo a estudiantes activos del run. */
export async function teacherCreateRunAnnouncement(runId, payload) {
	const res = await api.post(
		`/api/academic/teacher/runs/${runId}/announcements/`,
		payload,
	);
	return res.data;
}

/** Docente: calificaciones de un run. */
export async function teacherGetRunGrades(runId) {
	const res = await api.get(`/api/academic/teacher/runs/${runId}/grades/`);
	return res.data;
}

/** Docente: actualizar calificación de un estudiante. */
export async function teacherUpdateStudentGrade(
	runId,
	enrollmentId,
	finalGrade,
) {
	const res = await api.patch(`/api/academic/teacher/runs/${runId}/grades/`, {
		enrollment_id: enrollmentId,
		final_grade: finalGrade,
	});
	return res.data;
}


// --- NUEVOS ENDPOINTS DE EXÁMENES ---

export async function aulaStartExam(examId) {
    const res = await api.post(`/api/academic/start-exam/`, { exam_id: examId });
    return res.data;
}

export async function aulaGetExamQuestions(attemptId) {
    const res = await api.get(`/api/academic/exam-attempts/${attemptId}/questions/`);
    return res.data;
}

export async function aulaSaveExamProgress(attemptId, answers) {
    const res = await api.post(`/api/academic/save-exam-progress/`, {
        attempt_id: attemptId,
        answers: answers
    });
    return res.data;
}

export async function aulaSubmitExam(attemptId) {
    const res = await api.post(`/api/academic/submit-exam/`, { attempt_id: attemptId });
    return res.data;
}

export async function aulaGetExamFeedback(examId) {
    const res = await api.get(`/api/academic/exam-feedback/${examId}/`);
    return res.data;
}

export async function teacherUploadAikenExam(runId, file) {
    const form = new FormData();
    form.append("file", file);
    const res = await api.post(`/api/academic/teacher/runs/${runId}/exam/upload-aiken/`, form, {
        headers: { "Content-Type": "multipart/form-data" }
    });
    return res.data;
}

export async function teacherUploadFormativeAikenExam(unitId, file) {
    const form = new FormData();
    form.append("file", file);
    const res = await api.post(`/api/academic/teacher/units/${unitId}/exam/upload-aiken/`, form, {
        headers: { "Content-Type": "multipart/form-data" }
    });
    return res.data;
}

export async function teacherGetExamAttemptsReview(runId) {
    const res = await api.get(`/api/academic/teacher/runs/${runId}/exam-attempts/review/`);
    return res.data;
}

export async function teacherReviewExamAttempt(attemptId, action) {
    const res = await api.post(`/api/academic/teacher/exam-attempts/${attemptId}/review/`, { action });
    return res.data;
}

export async function teacherGetExamSettings(runId) {
    const res = await api.get(`/api/academic/teacher/runs/${runId}/exam/settings/`);
    return res.data;
}

export async function teacherUpdateExamSettings(runId, data) {
    const res = await api.patch(`/api/academic/teacher/runs/${runId}/exam/settings/`, data);
    return res.data;
}
